import { useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export const useFormSubmission = () => {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isVerifyingPayment, setIsVerifyingPayment] = useState(false);
  
    const handleFormSubmission = async (formData, config) => {
      const {
        apiEndpoint,
        successRoute,
        onSuccessCallback,
      } = config;
  
      const userConfirmed = await Swal.fire({
        title: "Are you sure?",
        text: "Please review your data before proceeding.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, proceed",
        cancelButtonText: "Cancel",
        customClass: {
          popup: "my-swal-popup",
          title: "my-swal-title",
          confirmButton: "my-swal-confirm",
          cancelButton: "my-swal-cancel",
        },
      });
  
      if (!userConfirmed.isConfirmed) return;
  
      setIsSubmitting(true);
  
      try {
        const response = await fetch(apiEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
  
        if (response.ok) {
          const result = await response.json();
          console.log(result);
          console.log(successRoute);
          // 🔹 Step 1: Success handling (if any further processing is needed)
          if (onSuccessCallback) {
            onSuccessCallback(result);
          }
          // 🔹 Step 2: Navigate to the success route with resultId (if applicable)
          if (result.resultId) {
            navigate(`${successRoute}/${result.resultId}`);
          } else {
            navigate(successRoute);
          }
  
        } else {
          const errorData = await response.json();
          
          // Handle validation errors (400 Bad Request)
          if (errorData.errors) {
            const errorMessages = Object.values(errorData.errors)
              .slice(0, 3) // Limit to first 3 errors
              .map(message => message)
              .join('<br>');
            
            await Swal.fire({
              title: "Form Errors",
              html: `Please correct these issues:<br><br>${errorMessages}`,
              icon: "error",
              confirmButtonText: "OK",
              customClass: {
                popup: "my-swal-popup",
                title: "my-swal-title",
                confirmButton: "my-swal-confirm",
              },
            });
            return;
          }
          
          // If no 'errors' field, show raw backend message or status text
          const backendMessage = errorData.message || response.statusText || "Something went wrong. Please try again.";
          
          Swal.fire({
            title: "Submission Failed",
            text: backendMessage,
            icon: "error",
            customClass: {
              popup: "my-swal-popup",
              title: "my-swal-title",
              confirmButton: "my-swal-confirm",
            },
          });
        }
      } catch (error) {
        console.error("Submission error:", error);
        Swal.fire({
          title: "Error",
          text: "An error occurred while submitting",
          icon: "error",
          customClass: {
            popup: "my-swal-popup",
            title: "my-swal-title",
            confirmButton: "my-swal-confirm",
          },
        });
      } finally {
        setIsSubmitting(false);
      }
    };
  
    return { handleFormSubmission, isSubmitting, isVerifyingPayment };
  };
  
  